<template>
  <div class="data-echarts">
    <div ref="chartContainer" style="height: 400px;"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  props: {
    compare1userDetailData: {
      type: Object,
      default: () => {},
    },

    compare2userDetailData: {
      type: Object,
      default: () => {},
    },

    compareValue1Name1: {
      type: String,
      default: "官方",
    },

    compareValue1Name2: {
      type: String,
      default: "官方",
    },
  },

  data() {
    return {
      option: {},
      myChart: null,
      posList: [
        "left",
        "right",
        "top",
        "bottom",
        "inside",
        "insideTop",
        "insideLeft",
        "insideRight",
        "insideBottom",
        "insideTopLeft",
        "insideTopRight",
        "insideBottomLeft",
        "insideBottomRight",
      ],
    };
  },
  mounted() {
    const chartDom = this.$refs.chartContainer;
    this.myChart = echarts.init(chartDom);
  },

  watch:{
    compare2userDetailData:{
      immediate:true,
      deep:true,
      handler(newVal){
        if (Object.keys(newVal).length !== 0) {
          this.renderChart()
        }
      }
    }
  },

  methods: {
    renderChart() {
      app.configParameters = {
        rotate: {
          min: -90,
          max: 90,
        },
        align: {
          options: {
            left: "left",
            center: "center",
            right: "right",
          },
        },
        verticalAlign: {
          options: {
            top: "top",
            middle: "middle",
            bottom: "bottom",
          },
        },
        position: {
          options: this.posList.reduce(function (map, pos) {
            map[pos] = pos;
            return map;
          }, {}),
        },
        distance: {
          min: 0,
          max: 100,
        },
      };

      app.config = {
        rotate: 90,
        align: "left",
        verticalAlign: "middle",
        position: "insideBottom",
        distance: 15,
        onChange: function () {
          const labelOption = {
            rotate: app.config.rotate,
            align: app.config.align,
            verticalAlign: app.config.verticalAlign,
            position: app.config.position,
            distance: app.config.distance,
          };
          this.myChart.setOption({
            series: [
              {
                label: labelOption,
              },
              {
                label: labelOption,
              },
              {
                label: labelOption,
              },
              {
                label: labelOption,
              },
            ],
          });
        },
      };

      const labelOption = {
        show: true,
        position: app.config.position,
        distance: app.config.distance,
        align: app.config.align,
        verticalAlign: app.config.verticalAlign,
        rotate: app.config.rotate,
        formatter: "{c}  {name|{a}}",
        fontSize: 16,
        rich: {
          name: {},
        },
      };
      this.option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: [
            "下载量",
            "注册",
            "活跃人数",
            "首冲人数",
            "充值总人数",
            "充值总金额",
            "投注人数",
            "净盈利",
            "游戏盈亏",
            "平台费",
            "手续费",
            "红利",
            "返水",
            "调账",
          ],
        },
        toolbox: {
          show: true,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar", "stack"] },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            data: [this.compareValue1Name1, this.compareValue1Name2 !=='官方'? this.compareValue1Name2:'' ],
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "下载量",
            type: "bar",
            barGap: 0,
            label: labelOption,
            emphasis: {
              focus: "series",
            },
            data: [
              this.compare1userDetailData.newRegisterUserCount,
              this.compareValue1Name2 !=='官方'? this.compare2userDetailData.newRegisterUserCount:'',
            ],
          },
          {
            name: "注册",
            type: "bar",
            label: labelOption,
            emphasis: {
              focus: "series",
            },
            data: [
              this.compare1userDetailData.newRegisterUserCount,
              this.compareValue1Name2 !=='官方'? this.compare2userDetailData.newRegisterUserCount :'',
            ],
          },
          {
            name: "活跃人数",
            type: "bar",
            label: labelOption,
            emphasis: {
              focus: "series",
            },
            data: [
              this.compare1userDetailData.activeUsersCount,
              this.compareValue1Name2 !=='官方'? this.compare2userDetailData.activeUsersCount :'' ,
            ],
          },
          {
            name: "首冲人数",
            type: "bar",
            label: labelOption,
            emphasis: {
              focus: "series",
            },
            data: [
              this.compare1userDetailData.firstDepositUsersCount,
              this.compareValue1Name2 !=='官方'? this.compare2userDetailData.firstDepositUsersCount:'',
            ],
          },
          {
            name: "充值总人数",
            type: "bar",
            label: labelOption,
            emphasis: {
              focus: "series",
            },
            data: [
              this.compare1userDetailData.depositTotalUsersCount,
              this.compareValue1Name2 !=='官方'?this.compare2userDetailData.depositTotalUsersCount:'',
            ],
          },
          {
            name: "充值总金额",
            type: "bar",
            label: labelOption,
            emphasis: {
              focus: "series",
            },
            data: [
              this.compare1userDetailData.sumMoneyInAmount,
              this.compareValue1Name2 !=='官方'?this.compare2userDetailData.sumMoneyInAmount:'',
            ],
          },
          {
            name: "投注人数",
            type: "bar",
            label: labelOption,
            emphasis: {
              focus: "series",
            },
            data: [
              this.compare1userDetailData.betTotalUserCount,
              this.compareValue1Name2 !=='官方'?this.compare2userDetailData.betTotalUserCount:'',
            ],
          },
          {
            name: "净盈利",
            type: "bar",
            label: labelOption,
            emphasis: {
              focus: "series",
            },
            data: [
              this.compare1userDetailData.netProfit,
              this.compareValue1Name2 !=='官方'?this.compare2userDetailData.netProfit:'',
            ],
          },
          {
            name: "游戏盈亏",
            type: "bar",
            label: labelOption,
            emphasis: {
              focus: "series",
            },
            data: [
              this.compare1userDetailData.profitLoss,
              this.compareValue1Name2 !=='官方'?this.compare2userDetailData.profitLoss:'',
            ],
          },
          {
            name: "平台费",
            type: "bar",
            label: labelOption,
            emphasis: {
              focus: "series",
            },
            data: [
              this.compare1userDetailData.platformCost,
              this.compareValue1Name2 !=='官方'?this.compare2userDetailData.platformCost:'',
            ],
          },
          {
            name: "手续费",
            type: "bar",
            label: labelOption,
            emphasis: {
              focus: "series",
            },
            data: [
              this.compare1userDetailData.moneyFee,
              this.compareValue1Name2 !=='官方'?this.compare2userDetailData.moneyFee:'',
            ],
          },
          {
            name: "红利",
            type: "bar",
            label: labelOption,
            emphasis: {
              focus: "series",
            },
            data: [
              this.compare1userDetailData.bonusAmount,
              this.compareValue1Name2 !=='官方'?this.compare2userDetailData.bonusAmount:'',
            ],
          },
          {
            name: "返水",
            type: "bar",
            label: labelOption,
            emphasis: {
              focus: "series",
            },
            data: [
              this.compare1userDetailData.receiveRebate,
              this.compareValue1Name2 !=='官方'?this.compare2userDetailData.receiveRebate:'',
            ],
          },
          {
            name: "调账",
            type: "bar",
            label: labelOption,
            emphasis: {
              focus: "series",
            },
            data: [
              this.compare1userDetailData.accountRegulation,
              this.compareValue1Name2 !=='官方'?this.compare2userDetailData.accountRegulation:'',
            ],
          },
        ],
      };
      this.myChart.setOption(this.option);

      // 在组件销毁时销毁图表
      this.$once("hook:beforeDestroy", () => {
        this.myChart.dispose();
      });
    },
  },
};
</script>
<style>
</style>